// ✅ Trekkin.app — trailNative.js
// Utilitário para guardar/ler GPX dos trilhos no storage nativo (Capacitor)

export const isNativePlatform = () =>
  typeof window !== "undefined" &&
  !!window.Capacitor?.isNativePlatform?.() &&
  !!window.Capacitor?.Plugins?.Filesystem;

const safeName = (name) =>
  String(name || "trail")
    .trim()
    .replace(/\.gpx$/i, "")
    .replace(/[^a-zA-Z0-9_-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "") || "trail";

export const buildTrailGpx = (points, name) => {
  if (!Array.isArray(points) || points.length < 1) return "";
  const safe = name || "Trekkin Trail";
  return (
    `<?xml version="1.0" encoding="UTF-8"?>\n` +
    `<gpx version="1.1" creator="Trekkin.app">\n<trk>\n` +
    `<name>${safe}</name>\n<trkseg>\n` +
    points
      .map((p) => {
        const ele =
          typeof p.ele === "number"
            ? `<ele>${p.ele}</ele>`
            : typeof p.alt === "number"
            ? `<ele>${p.alt}</ele>`
            : "";
        const ts = p.ts || p.time;
        const time = ts ? `<time>${new Date(ts).toISOString()}</time>` : "";
        return `<trkpt lat="${p.lat}" lon="${p.lon}">${ele}${time}</trkpt>`;
      })
      .join("\n") +
    `\n</trkseg>\n</trk>\n</gpx>`
  );
};

export const writeTrailGpxNative = async (gpxText, name) => {
  const fs = window?.Capacitor?.Plugins?.Filesystem;
  if (!fs?.writeFile) return null;
  const filename = `${safeName(name)}-${Date.now()}.gpx`;
  const path = `trail_${filename}`;
  try {
    await fs.writeFile({
      path,
      data: gpxText,
      directory: "DATA",
      encoding: "utf8",
    });
    return { path, directory: "DATA", filename };
  } catch {
    try {
      const b64 = btoa(unescape(encodeURIComponent(gpxText)));
      await fs.writeFile({
        path,
        data: b64,
        directory: "DATA",
      });
      return { path, directory: "DATA", filename, base64: true };
    } catch {
      return null;
    }
  }
};

export const readTrailGpxNative = async (entry) => {
  const fs = window?.Capacitor?.Plugins?.Filesystem;
  if (!fs?.readFile) return null;
  const ref =
    entry?.native?.trail ||
    entry?.native?.gpxTrail ||
    entry?.trailFile ||
    entry?.nativeTrail ||
    null;
  if (!ref?.path) return null;
  const directory = ref.directory || "DATA";
  try {
    const res = await fs.readFile({ path: ref.path, directory, encoding: "utf8" });
    if (typeof res?.data === "string") return res.data;
  } catch {}
  try {
    const res = await fs.readFile({ path: ref.path, directory });
    let data = res?.data;
    if (typeof data === "string") {
      try {
        data = decodeURIComponent(escape(atob(data)));
      } catch {}
      return data;
    }
  } catch {}
  return null;
};
